import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { ExtraFieldName } from '@shared/model'
import type { ExtraFieldModel } from '../../extra-field-model.hook'

import { useListsStore } from '@shared/model'

import { useTasksKanbanStore } from '../../../store'
import { useSelectConfigParser } from '../../select-config-parser.hook'
import { useExtraFieldModel } from '../../extra-field-model.hook'

interface SelectInitiatorReturn {
  name: ExtraFieldName
  placeholder: string
  model: ExtraFieldModel
  options: ComputedRef<AppSelectOption[]>
  isRequired: ComputedRef<boolean>
}

export const useSelectInitiator = (): SelectInitiatorReturn => {
  const listsStore = useListsStore()
  const tasksKanbanStore = useTasksKanbanStore()
  const name: ExtraFieldName = 'initiator'
  const placeholder = 'Select here'

  const model = useExtraFieldModel(name)

  const {
    options,
  } = useSelectConfigParser({ name })

  const isRequired = computed(() => {
    const taskType = tasksKanbanStore.getTaskType
    const optionalFields = taskType ? listsStore.getTaskTypes?.[taskType]?.optional_fields : undefined
    if (optionalFields?.includes(name)) return false

    return listsStore.getTasksKanbanConfig?.extra_fields[name]?.required || false
  })

  return {
    name,
    placeholder,
    model,
    options,
    isRequired,
  }
}
